$(function () {
  // 配達希望日プルダウン
  var now = new Date();
  var today_y = now.getFullYear();
  var today_m = now.getMonth();
  var today_d = now.getDate();

  var dayname = ['日', '月', '火', '水', '木', '金', '土'];
  var option_data = '<option value="最短でのお届け" selected>最短でのお届け</option>';

  for (var i = 7; i < 37; i++) {
    var now7 = new Date(today_y, today_m, today_d + i);
    var value_y = now7.getFullYear();
    var value_m = ("00" + (now7.getMonth() + 1)).slice(-2);
    var value_d = ("00" + (now7.getDate())).slice(-2);
    var value_dn = now7.getDay();
    //　正月対応用フラグ（1/1～9は非表示）
    //if (value_m == 1 && value_d >= 1 && value_d <= 13) {
    if ((value_m == 12 && value_d >= 29) || (value_m == 01 && value_d <= 13)) {
      continue;
    }
    option_data = option_data + '<option value="' + value_y + '/' + value_m + '/' + value_d + '（' + dayname[value_dn] + '）">' + value_y + '/' + value_m + '/' + value_d + '（' + dayname[value_dn] + '）</option > ';
  }
  $("#option_shipping_date").html(option_data);
})

$(function () {
  $(".template-cart .block_shipping_date article .option_switch").on("click", function () {
    $(this).next("div").slideToggle();
    $(this).children("span").toggleClass("close");
  })
})

// notes追加
$(function () {
  var text_box_receipt = '';
  var text_box_noshi = ''
  $("select[name='attributes[領収書の有無]']").on('change', function () {
    var now_radio = $("select[name='attributes[領収書の有無]']:checked").val();
    if (now_radio == '要') {
      text_box_receipt = '領収書あり\n';
    } else {
      text_box_receipt = '';
    }
    $("#CartSpecialInstructions").val(text_box_receipt + text_box_noshi);
  });
  $("select[name='attributes[贈る方にお伝えしたい内容]']").on('change', function () {
    var now_radio = $("select[name='attributes[贈る方にお伝えしたい内容]']:checked").val();
    if (now_radio == '不要') {
      text_box_noshi = '';
    } else {
      text_box_noshi = '贈る方にお伝えしたい内容あり\n';
    }
    $("#CartSpecialInstructions").val(text_box_receipt + text_box_noshi);
  });
  $("input[type='radio']").on('change', function () {
    var r = $("#CartSpecialInstructions").val();
    //console.log(r);
  })
})

// 送料ポップアップ
$(function () {
  $(".popup_shipping").on('click', function () {
    var this_id = "#table_shipping_" + $(this).data("itemid");
    $(this_id).fadeIn();
    $(".block_product_shipping_back").fadeIn();
  })
  $(".block_product_shipping").on('click', function () {
    $(".block_product_shipping").fadeOut();
    $(".block_product_shipping_back").fadeOut();
  })
})

// チルド商品受取日ポップアップ
$(function () {
  $('.chilled_popup_close').on('click', function () {
    $('#chilled_timetable').toggle();
  });
});

// 離脱ポップアップ
/*$(function () {
  $('#popup_show').click(function () {
    $('#samplePopup').fadeIn();
  })
  $('.closePopup').click(function () {
    $('#backGuide').fadeOut();
  })

})

$(function () {
  jQuery(document).ready(function () {
    (function (b) {
      var c = function () {
        this.initialize();
      };
      c.prototype = {
        initialize: function () {
          history.replaceState("beforeunload", null, null);
          history.pushState(null, null, null);
          b(window).on("popstate", b.proxy(this.popstate, this));
        },
        popstate: function (b) {
          if (b.originalEvent.state === "beforeunload") {
            viewBackGuide();
          }
        },
      };
      new c();
    })(jQuery);
    function viewBackGuide() {
      $('#backGuide').show();
    }
  });
});
*/
/*
$(window).on('beforeunload', function (e) {
  e.preventDefault();
  return '';
});*/